import { Button, ButtonProps, CircularProgress, styled } from "@mui/material";

interface Props extends ButtonProps {
  isLoading: boolean;
}

export function LoadingButton(props: Props) {
  const { children, isLoading, ...buttonProps } = props;
  return (
    <StyledButton {...buttonProps}>
      {isLoading ? (
        <>
          <CircularProgress size={14} />
          {children}
        </>
      ) : (
        children
      )}
    </StyledButton>
  );
}

const StyledButton = styled(Button)`
  display: inline-flex;
  gap: ${({ theme }) => theme.spacing(2)};
`;
